export const MAX_WIDTH_MENU = 500;

export const SUBHEADER = {
  TITLE: 'subheader_title',
  TIMESTAMP: 'subheader_timestamp',
  MODULE: 'subheader_module',
};

export const CARD = {
  TYPE: 'card_type',
  MODULE_LINK: 'card_module_link',
  ACTIONS: 'card_actions',
  TIME: 'card_time',
};
